import { render } from "./series-course-list-detail.vue?vue&type=template&id=ef7d9a76&scoped=true"
import script from "./series-course-list-detail.vue?vue&type=script&lang=ts"
export * from "./series-course-list-detail.vue?vue&type=script&lang=ts"

import "./series-course-list-detail.vue?vue&type=style&index=0&id=ef7d9a76&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ef7d9a76"

export default script